import React, { Component } from "react";
import SectionHeader from "../sectionHeader/sectionHeader";

const MediaAboutUs = () => {
  return (
    <div id="reviews">
      <div className="container media-about-us">
        <SectionHeader title="Media about us" subtitle="We are featured in " />
        <div className="row reviews-container justify-center text-center">
          <div>
            <a href="https://www.derrezensent.com">
              <img
                className="mx-auto"
                alt="der Rezensent"
                src={process.env.PUBLIC_URL + "/img/derRezensentLogo.svg"}
              />
            </a>
            <a
              className="article-title"
              href="https://www.derrezensent.com/duomly-review-the-best-app-to-learn-coding/"
            >
              <h3>
                Is Duomly the Best App to Learn Coding in 2023? Our Honest
                Review
              </h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaAboutUs;
